import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  EmptyDataContainer,
  EmptyDataText,
  ConfigAlarmButton,
  SeeAlarmButton,
  ActionButtonsContainer,
} from './styles';

interface AlarmNotificationActionButtonsProps {
  navigateToAlarmConfigPage: () => void;
  navigateToAlarmPage: () => void;
  isEmpty?: boolean;
}

export function AlarmNotificationActionButtons({
  navigateToAlarmConfigPage,
  navigateToAlarmPage,
  isEmpty = false,
}: AlarmNotificationActionButtonsProps) {
  const { t } = useTranslation('alarms-notification');

  return (
    <EmptyDataContainer>
      {/* @ts-ignore */}
      {isEmpty && <EmptyDataText>{t('noNotificationsMessage')}</EmptyDataText>}
      <ActionButtonsContainer>
        <ConfigAlarmButton type="link" onClick={navigateToAlarmConfigPage}>
          {t('configureAlarms')}
        </ConfigAlarmButton>
        <SeeAlarmButton type="link" onClick={navigateToAlarmPage}>
          {t('viewAlarms')}
        </SeeAlarmButton>
      </ActionButtonsContainer>
    </EmptyDataContainer>
  );
}
